import {AdminAccountState} from "@containers/adminAccounts/types";

export type StateKind = 'active' | 'inactive' | 'expired' | 'waiting' | 'multi' | 'tenant'

/**
 * The colour of a state on every system page: table rows, chips and the account switcher. Soft hues after
 * the legacy rows: the tenant violet, multi accounts blue, active green, inactive red, expired amber.
 */
export const STATE_COLORS: Record<StateKind, string> = {
	active: '#4e9f6b',
	inactive: '#d46a6a',
	expired: '#d9912f',
	waiting: '#d9912f',
	multi: '#4a86c5',
	tenant: '#8b6bd1',
}

export const ACCOUNT_STATE_KIND: Record<AdminAccountState, StateKind> = {
	YES: 'active',
	NO: 'inactive',
	EXPIRED: 'expired',
	EXTENDED: 'multi',
	TENANT: 'tenant',
}

/**
 * The state of a user, device or employee row: off (itself or its account, which takes it off too), past its
 * paid period, or working.
 */
export const rowStateKind = (row: { active?: boolean, accountActive?: boolean, activeUntil?: number | null }): StateKind | null => {
	if (row.active === false || row.accountActive === false) return 'inactive'
	if (row.activeUntil && row.activeUntil * 1000 < Date.now()) return 'expired'
	return row.active ? 'active' : null
}
